import React from 'react';
import { Card } from "tea-component";
import { useIntl } from 'umi';
import classnames from 'classnames';
import { getLanguage } from '@home/utils/common';
import { LANGUAGE_EN } from '@home/_config/config';
import CommonBubble from '@home/components/CommonBubble';
import BasicImage from '@home/components/BasicImage';
import './index.scss';
import dataFormat from '@home/utils/dbDataFormat/dataFormat';
import moment from 'moment';
import useStudioExplain from '@home/hooks/useStudioExplain';
import ProgressBar from '@home/components/ProgressBar';
import ACard from '@/pages/dashboard/components/ACard';
import { JumpType, navigate } from '@home/utils/utils';

export interface IMetricsCardWrap {
  className?: string;
  style?: React.CSSProperties;
  titleEn: string;
  titleCn: string;
  icons?: { img: string; url: string; }[];
  // 右上方icon浮窗解释内容
  iconTipsEn: string;
  iconTipsCn: string;
  // 标题icon图链接
  imgUrl?: string;
  rainbowKey: string;
  // 标题解释
  explainEn?: string;
  explainCn?: string;
  metricKey: string;
  valueKey: string;
  metrics: {
    metricObject: string;
    nameEn: string;
    nameCn: string;
    color: string;
    formatValue: string;
    preValue: string;
    valueStyle: React.CSSProperties;
  }[];
  data: any;
  dataKey: string;
}

const RevenueCard = (props: IMetricsCardWrap) => {
  const {
    className,
    style,
    titleEn,
    titleCn,
    explainEn,
    explainCn,
    rainbowKey,
    icons = [],
    iconTipsEn,
    iconTipsCn,
    imgUrl,
    data: cardData,
    dataKey,
    metricKey,
    valueKey,
    metrics = [],
  } = props || {};

  const { locale } = useIntl();
  const isEn = locale === LANGUAGE_EN;
  const { tipEn, tipCn } = useStudioExplain(rainbowKey, explainEn, explainCn);
  // 指标数据
  const metricData = cardData?.[dataKey]?.data?.[0]?.metrics?.[metricKey] || {};
  
  // 指标数据口径
  const valueData = metricData?.[valueKey] || {};
  // 副标题
  const { start_date, end_date } = valueData || {}; 
  const formatDate = (date: any) => (moment(date).isValid() ? moment(date).format('YYYY-MM-DD') : '');
  const startDate = formatDate(start_date);
  const endDate = formatDate(end_date);

  const value = valueData?.value;
  const predictValue = valueData?.forecast;
  const forecastValue = valueData?.forecast_real;
  const targetValue = valueData?.kpi;

  return (
    <Card className={classnames('dbh-revenue-card', className)} style={style}>
      <Card.Body
        title={
          <div className="dbh-revenue-card-title-container">
            <CommonBubble content={getLanguage(isEn, tipEn, tipCn)}>
              {imgUrl && <BasicImage src={imgUrl} className="dbh-revenue-card-title-img" />}
              {getLanguage(isEn, titleEn, titleCn)}
            </CommonBubble>
            {startDate && endDate && <div className="dbh-revenue-card-subtitle">{`${startDate}~${endDate}`}</div>}
            <div className="dbh-revenue-card-right-item">
              <div className="dbh-revenue-card-icon-container">
                {icons.map((icon, index) => (
                  <ACard key={index} url={icon?.url}>
                    <CommonBubble content={getLanguage(isEn, iconTipsEn, iconTipsCn)}>
                      <div className="dbh-revenue-card-right-icon" onClick={() => navigate(icon?.url, { jumpType: JumpType.Window })}>
                        <BasicImage src={icon.img} alt={`icon-${index}`} />
                      </div>
                    </CommonBubble>
                  </ACard>
                ))}
              </div>
            </div>
          </div>
        }
      >
        <div className="dbh-revenue-card-metrics">
          {metrics?.map((item, index) => {
            const metricValue = valueData?.[item.metricObject];
            const formattedValue = dataFormat({ value: metricValue, formatRule: item.formatValue });

            return (
              <div key={index} className="dbh-revenue-card-metrics-item">
                <div className="dbh-revenue-card-metrics-item-top">
                  <span className="dbh-revenue-card-metrics-item-dot" style={{ backgroundColor: item.color }} />
                  {getLanguage(isEn, item.nameEn, item.nameCn)}
                </div>
                <div className="dbh-revenue-card-metrics-item-value" style={item.valueStyle}>
                  {item?.preValue && metricValue ? `${item?.preValue}${formattedValue}` : formattedValue}
                </div>
              </div>
            );
          })}
        </div>
        <ProgressBar 
          value={value} 
          className={"dbh-revenue-card-progress-bar" }
          predictValue={predictValue}
          forecastValue={forecastValue} 
          targetValue={targetValue} 
          barColor="#5086F3"
          backgroundColor="#F2F3F5"
          predictBarColor="#CFE4FF"
          forecastBarColor="#B8BED1"
          markerColor="#69D19C"
          formattedValue={"bmk00"}
        />
      </Card.Body>
    </Card>
  );
};

export default RevenueCard;
